export default "__VITE_ASSET__a3d950d2__"